var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcStar16 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.36 2.889a.722.722 0 0 1 1.28 0l1.347 2.615 2.909.47a.71.71 0 0 1 .396 1.203l-2.08 2.09.452 2.91c.089.575-.515 1.007-1.037.744L8 11.596l-2.627 1.325c-.522.263-1.126-.17-1.037-.743L4.783 9.3a.06.06 0 0 0-.018-.056L2.708 7.177a.71.71 0 0 1 .396-1.203l2.91-.47 1.345-2.615z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcStar16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };